/**
 * File: src/components/hero.js
 * Mô tả: Component Hero Section hiển thị tựa game nổi bật nhất, banner hình ảnh, hỗ trợ đa ngôn ngữ Anh / Việt.
 * Liên quan: src/i18n/i18n-service.js, src/data/games.js, src/styles/components.css
 */

import { createElement } from '../utils/dom.js';
import { getLanguage, t, onLanguageChange } from '../i18n/i18n-service.js';

export const renderHero = (featuredGame) => {
  const section = createElement('section', {
    className: 'hero-section',
    attributes: { id: 'hero' },
  });

  const renderContent = () => {
    const bgImage = featuredGame?.coverImage || 'https://images.unsplash.com/photo-1542751371-adc38448a05e?q=80&w=1200&auto=format&fit=crop';
    const lang = getLanguage();
    const title = featuredGame?.title || 'SNT Games Studio';
    const description = lang === 'en'
      ? 'Ant Clash is a fast-paced 2D real-time strategy game where you command an ant colony to battle termites and conquer nests.'
      : featuredGame?.shortDescription;

    section.innerHTML = `
      <div class="hero-bg" style="background-image: url('${bgImage}');"></div>
      <div class="hero-overlay"></div>
      <div class="container">
        <div class="hero-content">
          <div class="hero-badge">${t('hero.badge')}</div>
          <h1 class="hero-title">${title}</h1>
          <p class="hero-description">${description}</p>
          <div style="display: flex; gap: 1rem; flex-wrap: wrap;">
            <a href="/games/ant-clash" class="btn btn-primary">
              <span>${t('hero.explore')}</span>
            </a>
            <a href="#games" class="btn btn-secondary">
              <span>${t('hero.allGames')}</span>
            </a>
          </div>
        </div>
      </div>
    `;
  };

  renderContent();
  onLanguageChange(() => renderContent());

  return section;
};
